import React from 'react';
import { Box } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import CommonCompleteCard from '../uiParts/CommonCompleteCard';
import Header from '../uiParts/Header';
import { gray20, gray80 } from '../../constants/colors';
import MetaTitle from '../utils/MetaTitle';
import { headerHeight, spHeaderHeight } from '../../constants/location';

const styles = {
  background: {
    width: '100%',
    height: '100vh',
    backgroundColor: gray20,
  },
  header: {
    height: headerHeight,
    position: 'fixed',
    '@media screen and (max-width:600px)': {
      height: spHeaderHeight,
      width: '100%',
      zIndex: '100',
    },
  },
  icon: {
    fontSize: '56px',
    color: gray80,
    mb: 3,
    '@media screen and (max-width: 600px)': {
      mb: 2,
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '-webkit-fill-available',
    paddingTop: headerHeight,
    '@media (max-width: 600px)': {
      paddingTop: '50%',
      height: 'auto',
      marginLeft: '16px',
      marginRight: '16px',
    },
  },
};

const PasswordResetComplete = (): React.ReactElement => {
  const icon = <MailOutlineIcon sx={styles.icon} />;
  const title = 'ご登録メールアドレスに\n認証メールを送信しました';
  const textAligin = 'left';
  const description =
    'パスワード再設定メールをお送りしました。\nお送りしたメールの内容に従ってパスワードを再設定してください。';
  const buttonText = '戻る';
  const buttonLink = '/';

  return (
    <Box sx={styles.background}>
      <MetaTitle />
      <Box sx={styles.header}>
        <Header />
      </Box>
      <Box sx={styles.container}>
        <CommonCompleteCard
          icon={icon}
          title={title}
          textAligin={textAligin}
          description={description}
          buttonText={buttonText}
          buttonLink={buttonLink}
        />
      </Box>
    </Box>
  );
};

export default PasswordResetComplete;
